<!-- src/components/modal/performance-appraisal-modal.vue -->
<template>
  <!-- Add Appraisal -->
  <div
    class="modal fade"
    id="add_performance_appraisal"
    tabindex="-1"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable dq-dialog"
    >
      <div class="modal-content dq-modal-content" :key="addKey">
        <!-- Header -->
        <div class="modal-header dq-modal-header">
          <div class="dq-titlewrap">
            <div class="dq-hero dq-hero-indigo">
              <i class="ti ti-chart-bar"></i>
            </div>
            <div>
              <h4 class="modal-title dq-title mb-0">Add Appraisal</h4>
              <div class="dq-subtitle">
                Evaluate competencies with clean scoring.
              </div>
            </div>
          </div>

          <button
            type="button"
            class="btn-close custom-btn-close dq-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>

        <form @submit.prevent="submitCreate">
          <div class="modal-body dq-modal-body">
            <div class="dq-info-row">
              <div class="dq-info-pill">
                <i class="ti ti-search"></i>
                Search employee & reviewer instantly
              </div>
              <div class="dq-info-pill">
                <i class="ti ti-stars"></i>
                Rate with consistency
              </div>
            </div>

            <!-- Top section -->
            <div class="dq-card mb-3">
              <div class="dq-card-head">
                <div class="dq-card-title">
                  <i class="ti ti-user-check"></i> Appraisal Info
                </div>
                <div class="dq-card-sub">
                  Pick employee, reviewer, date, and status.
                </div>
              </div>

              <div class="row g-3">
                <!-- Employee searchable -->
                <div class="col-md-6">
                  <label class="form-label dq-label"
                    >Employee <span class="text-danger">*</span></label
                  >

                  <div class="dropdown w-100">
                    <button
                      type="button"
                      class="btn btn-white border w-100 text-start dq-dd-btn d-flex align-items-center justify-content-between"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <span class="d-flex align-items-center gap-2">
                        <span class="dq-avatar"
                          ><i class="ti ti-user"></i
                        ></span>
                        <span class="dq-dd-title">{{
                          selectedEmployeeLabel || "Select employee"
                        }}</span>
                      </span>
                      <i class="ti ti-chevron-down"></i>
                    </button>

                    <div class="dropdown-menu w-100 p-2 dq-dd-menu">
                      <div class="mb-2">
                        <div class="input-icon-start position-relative">
                          <span class="input-icon-addon"
                            ><i class="ti ti-search"></i
                          ></span>
                          <input
                            v-model.trim="employeeQuery"
                            class="form-control dq-input"
                            placeholder="Search employee…"
                            @keydown.down.prevent="moveEmployeeActive(1)"
                            @keydown.up.prevent="moveEmployeeActive(-1)"
                            @keydown.enter.prevent="selectActiveEmployee()"
                          />
                        </div>
                      </div>

                      <div class="dq-search-list">
                        <button
                          v-for="(opt, idx) in filteredEmployees"
                          :key="'emp-' + opt.id"
                          type="button"
                          class="dropdown-item dq-dd-item"
                          :class="{ active: idx === employeeActiveIndex }"
                          @mouseenter="employeeActiveIndex = idx"
                          @click="pickEmployee(opt.id)"
                        >
                          <div class="dq-dd-row">
                            <div class="dq-avatar">
                              <i class="ti ti-user"></i>
                            </div>
                            <div class="flex-grow-1">
                              <div class="dq-dd-title">{{ opt.label }}</div>
                              <div class="dq-dd-sub">Employee</div>
                            </div>
                          </div>
                        </button>

                        <div
                          v-if="!filteredEmployees.length"
                          class="px-2 py-3 text-muted small"
                        >
                          No employees found.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="dq-help">Use ↑ ↓ and Enter to select.</div>
                </div>

                <!-- Reviewer searchable -->
                <div class="col-md-6">
                  <label class="form-label dq-label">Reviewer (optional)</label>

                  <div class="dropdown w-100">
                    <button
                      type="button"
                      class="btn btn-white border w-100 text-start dq-dd-btn d-flex align-items-center justify-content-between"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <span class="d-flex align-items-center gap-2">
                        <span class="dq-avatar"
                          ><i class="ti ti-user-star"></i
                        ></span>
                        <span class="dq-dd-title">{{
                          selectedReviewerLabel || "Select reviewer (optional)"
                        }}</span>
                      </span>
                      <i class="ti ti-chevron-down"></i>
                    </button>

                    <div class="dropdown-menu w-100 p-2 dq-dd-menu">
                      <div class="mb-2 d-flex gap-2">
                        <div
                          class="flex-grow-1 input-icon-start position-relative"
                        >
                          <span class="input-icon-addon"
                            ><i class="ti ti-search"></i
                          ></span>
                          <input
                            v-model.trim="reviewerQuery"
                            class="form-control dq-input"
                            placeholder="Search reviewer…"
                            @keydown.down.prevent="moveReviewerActive(1)"
                            @keydown.up.prevent="moveReviewerActive(-1)"
                            @keydown.enter.prevent="selectActiveReviewer()"
                          />
                        </div>

                        <button
                          type="button"
                          class="btn dq-btn dq-btn-muted"
                          @click="clearReviewer()"
                          title="Clear reviewer"
                        >
                          <i class="ti ti-x"></i>
                        </button>
                      </div>

                      <div class="dq-search-list">
                        <button
                          v-for="(opt, idx) in filteredReviewers"
                          :key="'rev-' + opt.id"
                          type="button"
                          class="dropdown-item dq-dd-item"
                          :class="{ active: idx === reviewerActiveIndex }"
                          @mouseenter="reviewerActiveIndex = idx"
                          @click="pickReviewer(opt.id)"
                        >
                          <div class="dq-dd-row">
                            <div class="dq-avatar">
                              <i class="ti ti-user-star"></i>
                            </div>
                            <div class="flex-grow-1">
                              <div class="dq-dd-title">{{ opt.label }}</div>
                              <div class="dq-dd-sub">Reviewer</div>
                            </div>
                          </div>
                        </button>

                        <div
                          v-if="!filteredReviewers.length"
                          class="px-2 py-3 text-muted small"
                        >
                          No reviewers found.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="dq-help">
                    Leave empty if reviewer is not assigned.
                  </div>
                </div>

                <!-- Date -->
                <div class="col-md-6">
                  <label class="form-label dq-label"
                    >Appraisal Date <span class="text-danger">*</span></label
                  >
                  <date-picker
                    v-model="form.appraisal_date"
                    class="form-control datetimepicker dq-input"
                    placeholder="dd/mm/yyyy"
                    :editable="true"
                    :clearable="false"
                    :input-format="dateFormat"
                  />
                </div>

                <!-- Status -->
                <div class="col-md-8">
                  <label class="form-label dq-label">Status</label>
                  <vue-select
                    v-model="form.status"
                    :options="['Active', 'Inactive']"
                    placeholder="Select Status"
                    class="dq-vselect"
                    :clearable="false"
                  />

                  <div class="mt-2 d-flex flex-wrap gap-2">
                    <span
                      v-if="form.status === 'Active'"
                      class="dq-chip dq-chip-ok"
                    >
                      <i class="ti ti-circle-check"></i> Active
                    </span>
                    <span v-else class="dq-chip dq-chip-muted">
                      <i class="ti ti-circle-minus"></i> Inactive
                    </span>
                  </div>
                </div>

                <!-- Comment -->
                <div class="col-12">
                  <label class="form-label dq-label">Overall Comment</label>
                  <textarea
                    v-model.trim="form.overall_comment"
                    class="form-control dq-input"
                    rows="3"
                    placeholder="Optional overall summary…"
                  ></textarea>
                </div>
              </div>
            </div>

            <!-- Tabs + tables -->
            <div class="dq-card">
              <div class="dq-card-head">
                <div class="dq-card-title">
                  <i class="ti ti-list-check"></i> Competencies
                </div>
                <div class="dq-card-sub">
                  Set competency level and rating per indicator.
                </div>
              </div>

              <ul class="nav dq-tabs nav-pills mb-3" role="tablist">
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link active"
                    data-bs-toggle="pill"
                    data-bs-target="#dq_technical_add"
                    type="button"
                  >
                    Technical
                    <span class="badge bg-light text-dark border ms-2">{{
                      form.tech?.length || 0
                    }}</span>
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    data-bs-toggle="pill"
                    data-bs-target="#dq_org_add"
                    type="button"
                  >
                    Organizational
                    <span class="badge bg-light text-dark border ms-2">{{
                      form.org?.length || 0
                    }}</span>
                  </button>
                </li>
              </ul>

              <div class="tab-content dq-tab-content">
                <!-- Technical -->
                <div class="tab-pane fade show active" id="dq_technical_add">
                  <div class="table-responsive dq-tablewrap">
                    <table class="table dq-table mb-0">
                      <thead>
                        <tr>
                          <th>Indicator</th>
                          <th>Expected</th>
                          <th>Set Value</th>
                          <th style="width: 140px">Rating</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, i) in form.tech" :key="'t-a-' + i">
                          <td class="fw-semibold">{{ row.indicator }}</td>
                          <td>
                            <span class="dq-chip dq-chip-muted">{{
                              row.expected_value
                            }}</span>
                          </td>
                          <td>
                            <vue-select
                              v-model="row.set_value"
                              :options="[
                                'None',
                                'Beginner',
                                'Intermediate',
                                'Advanced',
                                'Expert / Leader',
                              ]"
                              placeholder=""
                              class="dq-vselect"
                              :clearable="false"
                            />
                          </td>
                          <td>
                            <vue-select
                              v-model="row.rating"
                              :options="[1, 2, 3, 4, 5]"
                              placeholder=""
                              class="dq-vselect"
                              :clearable="false"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- Organizational -->
                <div class="tab-pane fade" id="dq_org_add">
                  <div class="table-responsive dq-tablewrap">
                    <table class="table dq-table mb-0">
                      <thead>
                        <tr>
                          <th>Indicator</th>
                          <th>Expected</th>
                          <th>Set Value</th>
                          <th style="width: 140px">Rating</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, i) in form.org" :key="'o-a-' + i">
                          <td class="fw-semibold">{{ row.indicator }}</td>
                          <td>
                            <span class="dq-chip dq-chip-muted">{{
                              row.expected_value
                            }}</span>
                          </td>
                          <td>
                            <vue-select
                              v-model="row.set_value"
                              :options="[
                                'None',
                                'Beginner',
                                'Intermediate',
                                'Advanced',
                                'Expert / Leader',
                              ]"
                              placeholder=""
                              class="dq-vselect"
                              :clearable="false"
                            />
                          </td>
                          <td>
                            <vue-select
                              v-model="row.rating"
                              :options="[1, 2, 3, 4, 5]"
                              placeholder=""
                              class="dq-vselect"
                              :clearable="false"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- /tab content -->
            </div>
          </div>

          <div class="modal-footer dq-modal-footer">
            <button
              type="button"
              class="btn dq-btn dq-btn-muted"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>

            <button
              type="submit"
              class="btn btn-primary dq-btn dq-btn-primary"
              :disabled="adding"
            >
              <span
                v-if="adding"
                class="spinner-border spinner-border-sm me-1"
              ></span>
              Add Appraisal<i class="ti ti-arrow-right ms-2"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Edit Appraisal -->
  <div
    class="modal fade"
    id="edit_performance_appraisal"
    tabindex="-1"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable dq-dialog"
    >
      <div class="modal-content dq-modal-content" :key="editKey">
        <!-- Header -->
        <div class="modal-header dq-modal-header">
          <div class="dq-titlewrap">
            <div class="dq-hero dq-hero-amber">
              <i class="ti ti-edit"></i>
            </div>
            <div>
              <h4 class="modal-title dq-title mb-0">Edit Appraisal</h4>
              <div class="dq-subtitle">Update review details and scores.</div>
            </div>
          </div>

          <button
            type="button"
            class="btn-close custom-btn-close dq-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>

        <form @submit.prevent="submitEdit">
          <div class="modal-body dq-modal-body">
            <!-- Top section -->
            <div class="dq-card mb-3">
              <div class="dq-card-head">
                <div class="dq-card-title">
                  <i class="ti ti-user-check"></i> Appraisal Info
                </div>
                <div class="dq-card-sub">
                  Pick employee, reviewer, date, and status.
                </div>
              </div>

              <div class="row g-3">
                <!-- Employee searchable -->
                <div class="col-md-6">
                  <label class="form-label dq-label"
                    >Employee <span class="text-danger">*</span></label
                  >

                  <div class="dropdown w-100">
                    <button
                      type="button"
                      class="btn btn-white border w-100 text-start dq-dd-btn d-flex align-items-center justify-content-between"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <span class="d-flex align-items-center gap-2">
                        <span class="dq-avatar"
                          ><i class="ti ti-user"></i
                        ></span>
                        <span class="dq-dd-title">{{
                          selectedEmployeeLabel || "Select employee"
                        }}</span>
                      </span>
                      <i class="ti ti-chevron-down"></i>
                    </button>

                    <div class="dropdown-menu w-100 p-2 dq-dd-menu">
                      <div class="mb-2">
                        <div class="input-icon-start position-relative">
                          <span class="input-icon-addon"
                            ><i class="ti ti-search"></i
                          ></span>
                          <input
                            v-model.trim="employeeQuery"
                            class="form-control dq-input"
                            placeholder="Search employee…"
                            @keydown.down.prevent="moveEmployeeActive(1)"
                            @keydown.up.prevent="moveEmployeeActive(-1)"
                            @keydown.enter.prevent="selectActiveEmployee()"
                          />
                        </div>
                      </div>

                      <div class="dq-search-list">
                        <button
                          v-for="(opt, idx) in filteredEmployees"
                          :key="'emp2-' + opt.id"
                          type="button"
                          class="dropdown-item dq-dd-item"
                          :class="{ active: idx === employeeActiveIndex }"
                          @mouseenter="employeeActiveIndex = idx"
                          @click="pickEmployee(opt.id)"
                        >
                          <div class="dq-dd-row">
                            <div class="dq-avatar">
                              <i class="ti ti-user"></i>
                            </div>
                            <div class="flex-grow-1">
                              <div class="dq-dd-title">{{ opt.label }}</div>
                              <div class="dq-dd-sub">Employee</div>
                            </div>
                          </div>
                        </button>

                        <div
                          v-if="!filteredEmployees.length"
                          class="px-2 py-3 text-muted small"
                        >
                          No employees found.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Reviewer searchable -->
                <div class="col-md-6">
                  <label class="form-label dq-label">Reviewer (optional)</label>

                  <div class="dropdown w-100">
                    <button
                      type="button"
                      class="btn btn-white border w-100 text-start dq-dd-btn d-flex align-items-center justify-content-between"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <span class="d-flex align-items-center gap-2">
                        <span class="dq-avatar"
                          ><i class="ti ti-user-star"></i
                        ></span>
                        <span class="dq-dd-title">{{
                          selectedReviewerLabel || "Select reviewer (optional)"
                        }}</span>
                      </span>
                      <i class="ti ti-chevron-down"></i>
                    </button>

                    <div class="dropdown-menu w-100 p-2 dq-dd-menu">
                      <div class="mb-2 d-flex gap-2">
                        <div
                          class="flex-grow-1 input-icon-start position-relative"
                        >
                          <span class="input-icon-addon"
                            ><i class="ti ti-search"></i
                          ></span>
                          <input
                            v-model.trim="reviewerQuery"
                            class="form-control dq-input"
                            placeholder="Search reviewer…"
                            @keydown.down.prevent="moveReviewerActive(1)"
                            @keydown.up.prevent="moveReviewerActive(-1)"
                            @keydown.enter.prevent="selectActiveReviewer()"
                          />
                        </div>

                        <button
                          type="button"
                          class="btn dq-btn dq-btn-muted"
                          @click="clearReviewer()"
                          title="Clear reviewer"
                        >
                          <i class="ti ti-x"></i>
                        </button>
                      </div>

                      <div class="dq-search-list">
                        <button
                          v-for="(opt, idx) in filteredReviewers"
                          :key="'rev2-' + opt.id"
                          type="button"
                          class="dropdown-item dq-dd-item"
                          :class="{ active: idx === reviewerActiveIndex }"
                          @mouseenter="reviewerActiveIndex = idx"
                          @click="pickReviewer(opt.id)"
                        >
                          <div class="dq-dd-row">
                            <div class="dq-avatar">
                              <i class="ti ti-user-star"></i>
                            </div>
                            <div class="flex-grow-1">
                              <div class="dq-dd-title">{{ opt.label }}</div>
                              <div class="dq-dd-sub">Reviewer</div>
                            </div>
                          </div>
                        </button>

                        <div
                          v-if="!filteredReviewers.length"
                          class="px-2 py-3 text-muted small"
                        >
                          No reviewers found.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Date -->
                <div class="col-md-6">
                  <label class="form-label dq-label"
                    >Appraisal Date <span class="text-danger">*</span></label
                  >
                  <date-picker
                    v-model="form.appraisal_date"
                    class="form-control datetimepicker dq-input"
                    placeholder="dd/mm/yyyy"
                    :editable="true"
                    :clearable="false"
                    :input-format="dateFormat"
                  />
                </div>

                <!-- Status -->
                <div class="col-md-6">
                  <label class="form-label dq-label">Status</label>
                  <vue-select
                    v-model="form.status"
                    :options="['Active', 'Inactive']"
                    placeholder="Select Status"
                    class="dq-vselect"
                    :clearable="false"
                  />

                  <div class="mt-2 d-flex flex-wrap gap-2">
                    <span
                      v-if="form.status === 'Active'"
                      class="dq-chip dq-chip-ok"
                    >
                      <i class="ti ti-circle-check"></i> Active
                    </span>
                    <span v-else class="dq-chip dq-chip-muted">
                      <i class="ti ti-circle-minus"></i> Inactive
                    </span>
                  </div>
                </div>

                <!-- Comment -->
                <div class="col-12">
                  <label class="form-label dq-label">Overall Comment</label>
                  <textarea
                    v-model.trim="form.overall_comment"
                    class="form-control dq-input"
                    rows="3"
                    placeholder="Optional overall summary…"
                  ></textarea>
                </div>
              </div>
            </div>

            <!-- Tabs + tables -->
            <div class="dq-card">
              <div class="dq-card-head">
                <div class="dq-card-title">
                  <i class="ti ti-list-check"></i> Competencies
                </div>
                <div class="dq-card-sub">
                  Set competency level and rating per indicator.
                </div>
              </div>

              <ul class="nav dq-tabs nav-pills mb-3" role="tablist">
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link active"
                    data-bs-toggle="pill"
                    data-bs-target="#dq_technical_edit"
                    type="button"
                  >
                    Technical
                    <span class="badge bg-light text-dark border ms-2">{{
                      form.tech?.length || 0
                    }}</span>
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    data-bs-toggle="pill"
                    data-bs-target="#dq_org_edit"
                    type="button"
                  >
                    Organizational
                    <span class="badge bg-light text-dark border ms-2">{{
                      form.org?.length || 0
                    }}</span>
                  </button>
                </li>
              </ul>

              <div class="tab-content dq-tab-content">
                <!-- Technical -->
                <div class="tab-pane fade show active" id="dq_technical_edit">
                  <div class="table-responsive dq-tablewrap">
                    <table class="table dq-table mb-0">
                      <thead>
                        <tr>
                          <th>Indicator</th>
                          <th>Expected</th>
                          <th>Set Value</th>
                          <th style="width: 140px">Rating</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, i) in form.tech" :key="'t-e-' + i">
                          <td class="fw-semibold">{{ row.indicator }}</td>
                          <td>
                            <span class="dq-chip dq-chip-muted">{{
                              row.expected_value
                            }}</span>
                          </td>
                          <td>
                            <vue-select
                              v-model="row.set_value"
                              :options="[
                                'None',
                                'Beginner',
                                'Intermediate',
                                'Advanced',
                                'Expert / Leader',
                              ]"
                              placeholder=""
                              class="dq-vselect"
                              :clearable="false"
                            />
                          </td>
                          <td>
                            <vue-select
                              v-model="row.rating"
                              :options="[1, 2, 3, 4, 5]"
                              placeholder=""
                              class="dq-vselect"
                              :clearable="false"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- Organizational -->
                <div class="tab-pane fade" id="dq_org_edit">
                  <div class="table-responsive dq-tablewrap">
                    <table class="table dq-table mb-0">
                      <thead>
                        <tr>
                          <th>Indicator</th>
                          <th>Expected</th>
                          <th>Set Value</th>
                          <th style="width: 140px">Rating</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, i) in form.org" :key="'o-e-' + i">
                          <td class="fw-semibold">{{ row.indicator }}</td>
                          <td>
                            <span class="dq-chip dq-chip-muted">{{
                              row.expected_value
                            }}</span>
                          </td>
                          <td>
                            <vue-select
                              v-model="row.set_value"
                              :options="[
                                'None',
                                'Beginner',
                                'Intermediate',
                                'Advanced',
                                'Expert / Leader',
                              ]"
                              placeholder=""
                              class="dq-vselect"
                              :clearable="false"
                            />
                          </td>
                          <td>
                            <vue-select
                              v-model="row.rating"
                              :options="[1, 2, 3, 4, 5]"
                              placeholder=""
                              class="dq-vselect"
                              :clearable="false"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- /tab content -->
            </div>
          </div>

          <div class="modal-footer dq-modal-footer">
            <button
              type="button"
              class="btn dq-btn dq-btn-muted"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="btn btn-primary dq-btn dq-btn-primary"
              :disabled="adding || !isEdit"
            >
              <span
                v-if="adding"
                class="spinner-border spinner-border-sm me-1"
              ></span>
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Delete Appraisal -->
  <div class="modal fade" id="delete_modal" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-md dq-dialog">
      <div class="modal-content dq-modal-content">
        <div class="modal-header dq-modal-header dq-danger-head">
          <div class="dq-titlewrap">
            <div class="dq-hero dq-hero-red">
              <i class="ti ti-trash"></i>
            </div>
            <div>
              <h4 class="modal-title dq-title mb-0">Confirm Delete</h4>
              <div class="dq-subtitle">This action cannot be undone.</div>
            </div>
          </div>

          <button
            type="button"
            class="btn-close custom-btn-close dq-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>

        <div class="modal-body dq-modal-body">
          <div class="dq-danger">
            <i class="ti ti-alert-triangle"></i>
            <div>
              <div class="dq-danger-title">Delete appraisal record?</div>
              <div class="dq-danger-sub">
                You’re about to permanently remove this appraisal.
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer dq-modal-footer">
          <button
            type="button"
            class="btn dq-btn dq-btn-muted"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>

          <button
            class="btn btn-danger dq-btn dq-btn-danger"
            :disabled="deleting"
            @click="confirmDelete"
          >
            <span
              v-if="deleting"
              class="spinner-border spinner-border-sm me-1"
            ></span>
            Delete
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  computed,
  ref,
  watch,
  onMounted,
  onBeforeUnmount,
  nextTick,
} from "vue";
import { useAppraisalStore } from "@/stores/appraisalStore";
import { useEmployeeStore } from "@/stores/employeeStore";
import { toast } from "@/utils/toast";

const props = defineProps({ editItem: { type: Object, default: null } });
const emit = defineEmits(["saved"]);
const deleting = ref(false);

const appStore = useAppraisalStore();
const empStore = useEmployeeStore();

const adding = computed(() => appStore.loading);
const dateFormat = "dd/MM/yyyy";

const addKey = ref(0);
const editKey = ref(0);

const cloneRows = (rows) => rows.map((r) => ({ ...r }));
const form = ref(blankForm());

function blankForm() {
  return {
    employee_id: "",
    reviewer_id: "",
    appraisal_date: null,
    status: "Active",
    overall_comment: "",
    tech: defaultTechnical(),
    org: defaultOrganizational(),
  };
}

function defaultTechnical() {
  return [
    {
      indicator: "Customer Experience",
      expected_value: "Intermediate",
      set_value: "",
      rating: null,
    },
    {
      indicator: "Marketing",
      expected_value: "Advanced",
      set_value: "",
      rating: null,
    },
    {
      indicator: "Management",
      expected_value: "Advanced",
      set_value: "",
      rating: null,
    },
    {
      indicator: "Administration",
      expected_value: "Advanced",
      set_value: "",
      rating: null,
    },
    {
      indicator: "Presentation Skill",
      expected_value: "Expert / Leader",
      set_value: "",
      rating: null,
    },
    {
      indicator: "Quality Of Work",
      expected_value: "Expert / Leader",
      set_value: "",
      rating: null,
    },
    {
      indicator: "Efficiency",
      expected_value: "Expert / Leader",
      set_value: "",
      rating: null,
    },
  ];
}
function defaultOrganizational() {
  return [
    {
      indicator: "Customer Experience",
      expected_value: "Intermediate",
      set_value: "",
      rating: null,
    },
    {
      indicator: "Marketing",
      expected_value: "Advanced",
      set_value: "",
      rating: null,
    },
    {
      indicator: "Management",
      expected_value: "Advanced",
      set_value: "",
      rating: null,
    },
    {
      indicator: "Administration",
      expected_value: "Advanced",
      set_value: "",
      rating: null,
    },
    {
      indicator: "Presentation Skill",
      expected_value: "Expert / Leader",
      set_value: "",
      rating: null,
    },
    {
      indicator: "Quality Of Work",
      expected_value: "Expert / Leader",
      set_value: "",
      rating: null,
    },
    {
      indicator: "Efficiency",
      expected_value: "Expert / Leader",
      set_value: "",
      rating: null,
    },
  ];
}

// const statusOptions = ["Active", "Inactive"];
// const levelOptions = [
//   "None",
//   "Beginner",
//   "Intermediate",
//   "Advanced",
//   "Expert / Leader",
// ];
// const ratingOptions = [1, 2, 3, 4, 5];

const employeeOptions = computed(() =>
  (empStore.employees || []).map((e) => ({
    id: e.id,
    label: `${e?.user?.first_name ?? e.first_name ?? ""} ${
      e?.user?.last_name ?? e.last_name ?? ""
    }`.trim(),
  }))
);




/* ---------------- Searchable Employee dropdown ---------------- */
const employeeQuery = ref("");
const employeeActiveIndex = ref(0);

const filteredEmployees = computed(() => {
  const q = employeeQuery.value.trim().toLowerCase();
  if (!q) return employeeOptions.value.slice(0, 10);
  return employeeOptions.value.filter((x) =>
    (x.label || "").toLowerCase().includes(q)
  );
});

const selectedEmployeeLabel = computed(() => {
  const id = form.value.employee_id;
  if (!id) return "";
  return (
    employeeOptions.value.find((x) => String(x.id) === String(id))?.label || ""
  );
});

function moveEmployeeActive(dir) {
  const len = filteredEmployees.value.length;
  if (!len) return;
  employeeActiveIndex.value = (employeeActiveIndex.value + dir + len) % len;
  scrollActiveIntoView();
}
function pickEmployee(id) {
  form.value.employee_id = id;
  employeeQuery.value = "";
  employeeActiveIndex.value = 0;
  document.activeElement?.blur?.();
}
function selectActiveEmployee() {
  const opt = filteredEmployees.value[employeeActiveIndex.value];
  if (opt) pickEmployee(opt.id);
}

/* ---------------- Searchable Reviewer dropdown ---------------- */
const reviewerQuery = ref("");
const reviewerActiveIndex = ref(0);

const filteredReviewers = computed(() => {
  const q = reviewerQuery.value.trim().toLowerCase();
  if (!q) return employeeOptions.value.slice(0, 10);
  return employeeOptions.value.filter((x) =>
    (x.label || "").toLowerCase().includes(q)
  );
});

const selectedReviewerLabel = computed(() => {
  const id = form.value.reviewer_id;
  if (!id) return "";
  return (
    employeeOptions.value.find((x) => String(x.id) === String(id))?.label || ""
  );
});

function moveReviewerActive(dir) {
  const len = filteredReviewers.value.length;
  if (!len) return;
  reviewerActiveIndex.value = (reviewerActiveIndex.value + dir + len) % len;
  scrollActiveIntoView();
}
function pickReviewer(id) {
  form.value.reviewer_id = id;
  reviewerQuery.value = "";
  reviewerActiveIndex.value = 0;
  document.activeElement?.blur?.();
}
function clearReviewer() {
  form.value.reviewer_id = "";
  reviewerQuery.value = "";
  reviewerActiveIndex.value = 0;
}
function selectActiveReviewer() {
  const opt = filteredReviewers.value[reviewerActiveIndex.value];
  if (opt) pickReviewer(opt.id);
}

async function scrollActiveIntoView() {
  await nextTick();
  const menus = document.querySelectorAll(".dq-dd-menu .dq-search-list");
  const list = Array.from(menus).find((el) => el.offsetParent !== null);
  if (!list) return;
  const active = list.querySelector(".dropdown-item.active");
  active?.scrollIntoView({ block: "nearest" });
}

/* ---------------- Form sync ---------------- */
function resetForm() {
  const blank = blankForm();
  for (const k in blank) form.value[k] = blank[k];
  employeeQuery.value = "";
  reviewerQuery.value = "";
  employeeActiveIndex.value = 0;
  reviewerActiveIndex.value = 0;
}

watch(
  () => props.editItem,
  (val) => {
    if (val) {
      form.value.employee_id = val.employee_id || "";
      form.value.reviewer_id = val.reviewer_id || "";
      form.value.appraisal_date = val.appraisal_date
        ? new Date(val.appraisal_date)
        : null;
      form.value.status = val.status || "Active";
      form.value.overall_comment = val.overall_comment || "";

      const tech = (val.items || [])
        .filter((i) => i.category === "Technical")
        .map((i) => ({
          indicator: i.indicator,
          expected_value: i.expected_value,
          set_value: i.set_value,
          rating: i.rating ?? null,
        }));

      const org = (val.items || [])
        .filter((i) => i.category === "Organizational")
        .map((i) => ({
          indicator: i.indicator,
          expected_value: i.expected_value,
          set_value: i.set_value,
          rating: i.rating ?? null,
        }));

      form.value.tech = tech.length ? cloneRows(tech) : defaultTechnical();
      form.value.org = org.length ? cloneRows(org) : defaultOrganizational();

      employeeQuery.value = "";
      reviewerQuery.value = "";
      editKey.value++;
    } else {
      resetForm();
    }
  },
  { immediate: true }
);

const isEdit = computed(() => !!props.editItem?.id);

function toYMD(d) {
  if (!d) return null;
  if (typeof d === "string") return d;
  try {
    const dt = new Date(d);
    const y = dt.getFullYear();
    const m = String(dt.getMonth() + 1).padStart(2, "0");
    const day = String(dt.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  } catch {
    return null;
  }
}




function buildItemsPayload() {
  const items = [];
  (form.value.tech || []).forEach((row) => {
    items.push({
      category: "Technical",
      indicator: row.indicator,
      expected_value: row.expected_value || null,
      set_value: row.set_value || null,
      rating: row.rating ?? null,
    });
  });
  (form.value.org || []).forEach((row) => {
    items.push({
      category: "Organizational",
      indicator: row.indicator,
      expected_value: row.expected_value || null,
      set_value: row.set_value || null,
      rating: row.rating ?? null,
    });
  });
  return items;
}

async function submitCreate() {
  if (!form.value.employee_id || !form.value.appraisal_date) {
    toast("Employee and Appraisal Date are required", "error");
    return;
  }
  const payload = {
    employee_id: form.value.employee_id,
    reviewer_id: form.value.reviewer_id || null,
    appraisal_date: toYMD(form.value.appraisal_date),
    status: form.value.status || "Active",
    overall_comment: form.value.overall_comment || null,
    items: buildItemsPayload(),
  };
  await appStore.create(payload);
  closeNew();
  resetForm();
  addKey.value++;
  emit("saved");
}

async function submitEdit() {
  if (!props.editItem?.id) return;
  const payload = {
    employee_id: form.value.employee_id,
    reviewer_id: form.value.reviewer_id || null,
    appraisal_date: toYMD(form.value.appraisal_date),
    status: form.value.status || "Active",
    overall_comment: form.value.overall_comment || null,
    items: buildItemsPayload(),
  };
  await appStore.update(props.editItem.id, payload);
  closeEdit();
  resetForm();
  editKey.value++;
  emit("saved");
}

function closeNew() {
  document
    .querySelector('#add_performance_appraisal [data-bs-dismiss="modal"]')
    ?.click();
}
function closeEdit() {
  document
    .querySelector('#edit_performance_appraisal [data-bs-dismiss="modal"]')
    ?.click();
}

async function confirmDelete() {
  deleting.value = true;
  try {
    if (!props.editItem?.id) return;
    await appStore.remove(props.editItem.id);
    emit("saved");
  } catch (e) {
    console.error(e);
  } finally {
    deleting.value = false;
  }
}

let cleanup = null;
onMounted(async () => {
  if (
    !empStore.employees?.length &&
    typeof empStore.fetchEmployees === "function"
  ) {
    await empStore.fetchEmployees();
  }

  const addEl = document.getElementById("add_performance_appraisal");
  const editEl = document.getElementById("edit_performance_appraisal");

  const handleAddShow = () => {
    resetForm();
    addKey.value++;
  };
  const handleAddHidden = () => resetForm();
  const handleEditHidden = () => {
    resetForm();
    editKey.value++;
  };

  addEl?.addEventListener("show.bs.modal", handleAddShow);
  addEl?.addEventListener("hidden.bs.modal", handleAddHidden);
  editEl?.addEventListener("hidden.bs.modal", handleEditHidden);

  cleanup = () => {
    addEl?.removeEventListener("show.bs.modal", handleAddShow);
    addEl?.removeEventListener("hidden.bs.modal", handleAddHidden);
    editEl?.removeEventListener("hidden.bs.modal", handleEditHidden);
  };
});
onBeforeUnmount(() => cleanup && cleanup());
</script>

<style scoped>
/* Same styling as promotion modal */
.dq-dialog {
  max-width: 980px;
}

/* Shell */
.dq-modal-content {
  border-radius: 22px;
  border: none;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.08),
    0 40px 90px rgba(15, 23, 42, 0.14);
}
.dq-modal-header {
  padding: 18px 20px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  background: linear-gradient(180deg, rgba(99, 102, 241, 0.1), #fff);
}
.dq-danger-head {
  background: linear-gradient(180deg, rgba(239, 68, 68, 0.12), #fff);
}
.dq-modal-body {
  padding: 16px 20px;
}

/* Reliable scroll + sticky footer */
.modal-dialog.modal-dialog-scrollable .modal-content {
  max-height: 92vh;
  display: flex;
  flex-direction: column;
}
.modal-dialog.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
  max-height: calc(92vh - 150px);
  overscroll-behavior: contain;
}
.dq-modal-footer {
  padding: 14px 20px;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  background: #fff;
  position: sticky;
  bottom: 0;
  z-index: 2;
}

/* Header */
.dq-titlewrap {
  display: flex;
  align-items: center;
  gap: 12px;
}
.dq-title {
  font-weight: 950;
  letter-spacing: -0.35px;
}
.dq-subtitle {
  font-size: 0.82rem;
  color: rgba(15, 23, 42, 0.6);
}
.dq-close {
  opacity: 0.9;
}
.dq-close:hover {
  opacity: 1;
}

/* Hero */
.dq-hero {
  width: 46px;
  height: 46px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.dq-hero-indigo {
  background: rgba(99, 102, 241, 0.14);
  color: rgb(79, 70, 229);
}
.dq-hero-amber {
  background: rgba(245, 158, 11, 0.14);
  color: rgb(217, 119, 6);
}
.dq-hero-red {
  background: rgba(239, 68, 68, 0.14);
  color: rgb(220, 38, 38);
}

/* Cards */
.dq-card {
  border-radius: 18px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  background: #fff;
  padding: 14px;
}
.dq-card-head {
  padding: 2px 2px 10px;
}
.dq-card-title {
  font-weight: 950;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.dq-card-sub {
  margin-top: 6px;
  font-size: 0.82rem;
  color: rgba(15, 23, 42, 0.6);
}

/* Tips */
.dq-info-row {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.dq-info-pill {
  flex: 1 1 260px;
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 10px 12px;
  border-radius: 16px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  background: rgba(15, 23, 42, 0.02);
  color: rgba(15, 23, 42, 0.72);
  font-weight: 800;
  font-size: 0.82rem;
}
.dq-info-pill i {
  color: rgba(99, 102, 241, 0.85);
}

/* Inputs */
.dq-label {
  font-size: 0.82rem;
  font-weight: 900;
}
.dq-input {
  border-radius: 14px;
  padding: 10px 12px;
}
.dq-input:focus {
  border-color: rgba(99, 102, 241, 0.35);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
}
.dq-help {
  margin-top: 6px;
  font-size: 0.8rem;
  color: rgba(15, 23, 42, 0.55);
}

/* Dropdown */
.dq-dd-btn {
  border-radius: 14px;
  padding: 10px 12px;
}
.dq-dd-menu {
  border-radius: 16px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.16);
}
.dq-search-list {
  max-height: 280px;
  overflow: auto;
  overscroll-behavior: contain;
}
.dq-dd-item {
  border-radius: 12px;
  padding: 10px 10px;
}
.dq-dd-item:hover {
  background: rgba(15, 23, 42, 0.04);
}
.dq-dd-row {
  display: flex;
  gap: 10px;
  align-items: center;
}
.dq-avatar {
  width: 34px;
  height: 34px;
  border-radius: 12px;
  background: rgba(99, 102, 241, 0.1);
  color: rgb(79, 70, 229);
  display: flex;
  align-items: center;
  justify-content: center;
}
.dq-dd-title {
  font-weight: 900;
}
.dq-dd-sub {
  font-size: 0.78rem;
  color: rgba(15, 23, 42, 0.55);
}

/* Buttons */
.dq-btn {
  border-radius: 12px;
  padding: 10px 16px;
  font-weight: 900;
}
.dq-btn-muted {
  background: rgba(15, 23, 42, 0.04);
  border: 1px solid rgba(15, 23, 42, 0.06);
}
.dq-btn-primary {
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.1);
}
.dq-btn-danger {
  box-shadow: 0 12px 24px rgba(239, 68, 68, 0.12);
}

/* Chips */
.dq-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 14px;
  font-size: 0.82rem;
  font-weight: 900;
  border: 1px solid rgba(15, 23, 42, 0.06);
}
.dq-chip-muted {
  background: rgba(15, 23, 42, 0.04);
  color: rgba(15, 23, 42, 0.7);
}
.dq-chip-ok {
  background: rgba(16, 185, 129, 0.12);
  color: rgb(5, 150, 105);
}

/* Tabs */
.dq-tabs .nav-link {
  border-radius: 14px;
  font-weight: 900;
  padding: 10px 12px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  color: rgba(15, 23, 42, 0.75);
  background: rgba(15, 23, 42, 0.02);
}
.dq-tabs .nav-link.active {
  background: rgba(99, 102, 241, 0.1);
  border-color: rgba(99, 102, 241, 0.18);
  color: rgb(79, 70, 229);
}

/* Tables */
.dq-tablewrap {
  border-radius: 16px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  overflow: hidden;
}
.dq-table thead th {
  font-size: 0.82rem;
  font-weight: 950;
  color: rgba(15, 23, 42, 0.72);
  background: rgba(15, 23, 42, 0.02);
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
}
.dq-table td {
  vertical-align: middle;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
}

/* Delete warning */
.dq-danger {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 14px;
  border-radius: 18px;
  border: 1px solid rgba(239, 68, 68, 0.14);
  background: rgba(239, 68, 68, 0.08);
}
.dq-danger i {
  font-size: 18px;
  color: rgb(220, 38, 38);
  margin-top: 2px;
}
.dq-danger-title {
  font-weight: 950;
}
.dq-danger-sub {
  margin-top: 6px;
  font-size: 0.82rem;
  color: rgba(15, 23, 42, 0.7);
}

@media (max-width: 576px) {
  .dq-dialog {
    max-width: 96vw;
    margin: 0.75rem auto;
  }
}
</style>
